import { FieldType } from '../../types/enums'
import { ItemAttribute } from '../../types/types'
import { unitTypeToShort } from '../../utils/functions/enumToText'

export const useSaleItemAttributes = () => {
  const sortRequiredFirst = (a: ItemAttribute, b: ItemAttribute): number => {
    if (a.isRequired && !b.isRequired) return -1
    if (!a.isRequired && b.isRequired) return 1
    return 0
  }

  const formatAttributeValue = (attribute: ItemAttribute): string => {
    const { fieldType, value, unit } = attribute

    if (fieldType === FieldType.CHECKBOX) {
      return value === true || value === 'true' ? 'Да' : 'Нет'
    }

    if (fieldType === FieldType.MULTISELECT && typeof value === 'string') {
      return value.replace(/[\[\]"]/g, '').trim()
    }

    const valueStr = String(value)
    const unitStr = unit !== undefined && unit !== -1 ? ` ${unitTypeToShort(unit)}` : ''

    return `${valueStr}${unitStr}`
  }

  return { sortRequiredFirst, formatAttributeValue }
}
